const protobufjs = require('../protobufjs');
const {fromGRPC, toGRPC} = require('../grpc');

function encode(type, value) {
  return type.prototype.__proto(protobufjs).encode(toGRPC(type, value)).finish();
}

function decode(type, buffer) {
  return fromGRPC(type, type.prototype.__proto(protobufjs).decode(buffer));
}

module.exports = {encode, decode};